module.exports = __webpack_public_path__ + "static/tnw-startup-awards-654e5037eff87cba8c655ea23743731c.png";